<mat-accordion class="schema-accordion">
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>schema</mat-icon>
                <span>{{'OutputSchemaDefinition' | translate}}</span>
            </mat-panel-title>
            <mat-panel-description>
                {{'OutputSchemaDescription' | translate}}
            </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="schemaForm">
            <div formArrayName="fields" class="fields-container">
                @for (field of fields.controls; track field; let i = $index) {
                    <div class="field-group" [formGroupName]="i">
                        <div class="field-header">
                            <h4>Field {{i + 1}}</h4>
                            @if (fields.length > 1) {
                                <button 
                                    mat-icon-button 
                                    color="warn" 
                                    type="button"
                                    (click)="removeField(i)"
                                    [title]="'RemoveField' | translate">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                        </div>

                        <div class="field-inputs">
                            <mat-form-field appearance="outline" class="field-name-select">
                                <mat-label>{{'FieldName' | translate}}</mat-label>
                                <mat-select 
                                    formControlName="field_name_select" 
                                    (selectionChange)="onFieldNameSelectChange(i)">
                                    <mat-select-trigger>
                                        {{ field.get('field_name_select')?.value === 'custom' ? 'Custom field name...' : field.get('field_name_select')?.value }}
                                    </mat-select-trigger>
                                    @for (suggestedField of suggestedFields; track suggestedField.value) {
                                        <mat-option [value]="suggestedField.value">
                                            <div class="field-option">
                                                <span class="field-option-label">{{ suggestedField.label }}</span>
                                                @if (suggestedField.value !== 'custom') {
                                                    <span class="field-option-description">{{ suggestedField.description }}</span>
                                                }
                                            </div>
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            @if (isCustomFieldName(i)) {
                                <mat-form-field appearance="outline" class="field-name-custom">
                                    <mat-label>{{'CustomFieldName' | translate}}</mat-label>
                                    <input 
                                        matInput 
                                        formControlName="field_name_custom"
                                        (input)="onCustomFieldNameChange(i)"
                                        placeholder="e.g., my_custom_field"
                                        [attr.aria-label]="'CustomFieldName' | translate">
                                    @if (getFieldErrorMessage(i, 'field_name')) {
                                        <mat-error>{{ getFieldErrorMessage(i, 'field_name') }}</mat-error>
                                    }
                                    <mat-hint>{{'FieldNamingRulesShort' | translate}}</mat-hint>
                                </mat-form-field>
                            }

                            <mat-form-field appearance="outline" class="field-type-input">
                                <mat-label>{{'FieldType' | translate}}</mat-label>
                                <mat-select formControlName="field_type">
                                    @for (type of fieldTypes; track type) {
                                        <mat-option [value]="type">{{ getFieldTypeLabel(type) }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="field-default-input">
                                <mat-label>{{'DefaultValue' | translate}} ({{'Optional' | translate}})</mat-label>
                                <input 
                                    matInput 
                                    formControlName="default_value" 
                                    placeholder="Optional default value">
                            </mat-form-field>
                        </div>

                        <div class="expected-values-section">
                            <label class="expected-values-label">
                                {{'ExpectedValues' | translate}} ({{'Optional' | translate}}) - Press Enter to add value
                            </label>
                            
                            <mat-form-field appearance="outline" class="expected-value-input">
                                <mat-label>{{'AddExpectedValue' | translate}}</mat-label>
                                <input 
                                    matInput 
                                    placeholder="Type and press Enter"
                                    (keydown)="onExpectedValueKeydown(i, $event)"
                                    (blur)="addExpectedValue(i, $event)">
                            </mat-form-field>

                            <div class="expected-values-chips">
                                @for (value of field.get('expected_values')?.value; track value; let j = $index) {
                                    <mat-chip class="expected-value-chip">
                                        {{ value }}
                                        <button 
                                            matChipRemove 
                                            (click)="removeExpectedValue(i, j)"
                                            [attr.aria-label]="'Remove ' + value">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </form>

        <div class="actions-container">
            <button 
                mat-button 
                mat-stroked-button 
                color="primary" 
                type="button"
                (click)="addField()">
                <mat-icon>add</mat-icon>
                <span>{{'AddField' | translate}}</span>
            </button>

            <button 
                mat-button 
                mat-flat-button 
                color="primary" 
                type="button"
                [disabled]="schemaForm.invalid || isSaving"
                (click)="saveSchema()">
                @if (isSaving) {
                    <span>{{'Saving' | translate}}...</span>
                } @else {
                    <span>{{'SaveSchema' | translate}}</span>
                }
            </button>
        </div>
    </mat-expansion-panel>
</mat-accordion>
